import { useEffect, useState } from 'react';

export const NEXT_DROP_DATE = '2026-10-01T12:00:00-04:00';

const timeLeft = () => {
  const distance = Math.max(0, new Date(NEXT_DROP_DATE).getTime() - Date.now());
  return {
    days: Math.floor(distance / 86400000),
    hours: Math.floor((distance / 3600000) % 24),
    minutes: Math.floor((distance / 60000) % 60),
    seconds: Math.floor((distance / 1000) % 60),
  };
};

export function DropCountdown() {
  const [remaining, setRemaining] = useState(timeLeft);
  useEffect(() => {
    const timer = window.setInterval(() => setRemaining(timeLeft()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <section className="border-y border-[#D1D1D6] bg-[#1E1E1E] px-5 py-12 text-white sm:px-8 lg:px-12" data-testid="drop-countdown-section">
    <div className="mx-auto grid max-w-[1500px] gap-8 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-5"><p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.28em] text-[#C7D1C3]">Drop 04 / October 1</p><h2 className="mt-3 font-syne text-4xl font-extrabold uppercase leading-[0.9] sm:text-5xl">Next release<br />on the clock.</h2></div>
      <div className="grid grid-cols-4 gap-2 sm:gap-4 lg:col-span-6 lg:col-start-7" data-testid="drop-countdown-values">
        {Object.entries(remaining).map(([label, value]) => <div key={label} className="border-l border-white/30 pl-3 sm:pl-5"><p className="font-syne text-3xl font-extrabold sm:text-5xl" data-testid={`drop-countdown-${label}`}>{String(value).padStart(2, '0')}</p><p className="mt-2 font-mono2 text-[8px] uppercase tracking-[0.2em] text-white/60">{label}</p></div>)}
      </div>
    </div>
  </section>;
}